
<template>
  <div>
    <div class="find">
      <div class="seach-top">
        <el-form
          ref="searchForm"
          :inline="true"
          :model="searchForm"
          class="demo-form-inline"
        >

          <el-row>
            <el-col :span="16">
              <el-row>
                <el-form-item label="试剂耗材信息">
                  <el-input
                    v-model="searchForm.shijihaocaiMingcheng"
                    placeholder="名称/品牌/货号/CAS号"
                    size="small"
                    clearable
                  />
                </el-form-item>

                <el-form-item :label="'申请者'">
                  <el-select v-model="searchForm.shenqingzheUserId" placeholder="申请者" size="small" clearable="">
                    <el-option
                      v-for="item in ketiMemberList"
                      :key="item.userKey"
                      :label="item.userName"
                      :value="item.userKey"
                    />
                  </el-select>
                </el-form-item>
                <el-form-item :label="'使用者'">
                  <el-select v-model="searchForm.shiyongzheUserId" placeholder="使用者" size="small" clearable="">
                    <el-option
                      v-for="item in ketiMemberList"
                      :key="item.userKey"
                      :label="item.userName"
                      :value="item.userKey"
                    />
                  </el-select>
                </el-form-item>
              </el-row>
              <el-row>
                <el-form-item :label="'课'+getSpac+'题'+getSpac+'信息'">
                  <el-input v-model="searchForm.ketiMingcheng" placeholder="课题名称/实验名称/用途" size="small" clearable />
                </el-form-item>
                <el-form-item :label="'状'+getSpac+'态'">
                  <el-select v-model="searchForm.statusDictKey" placeholder="状态" size="small" clearable="" disabled>
                    <el-option
                      v-for="item in getComboxData('F01')"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    />
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" size="small" @click="handleSearch">
                    查询
                    <i class="el-icon-search el-icon--right" />
                  </el-button>
                </el-form-item>
              </el-row>
            </el-col>
            <el-col :span="8">
              <div class="btn-box" style="float: right;">
                <el-row>
                  <!-- <el-form-item>
                    <el-button type="primary" size="small" @click="handleAdd">
                      采购申请
                      <i class="el-icon-plus el-icon--right" />
                    </el-button>
                  </el-form-item>
                  <el-form-item class="upload-btn">
                    <upload-excel-component style="display:inline;" :on-success="handleImportSuccess" :before-upload="handleBeforeUpload" />
                  </el-form-item>
                  <el-form-item>
                    <el-button size="small" type="primary" @click="handleExport">
                      导出
                      <i class="el-icon-download el-icon--right" />
                    </el-button>
                  </el-form-item> -->
                </el-row>
                <el-row>
                  <!-- <el-form-item>
                    <el-button type="primary" size="small" @click="handleSearch">
                      查询
                      <i class="el-icon-search el-icon--right" />
                    </el-button>
                  </el-form-item> -->
                  <el-form-item>
                    <el-button type="primary" size="small" @click="handleStockOut()">
                      申领发放
                      <i class="el-icon-back el-icon--right" />
                    </el-button>
                  </el-form-item>
                  <!-- <el-form-item>
                    <el-button type="primary" size="small" @click="handleShowInOut()">
                      入出库详细
                      <i class="el-icon-back el-icon--right" />
                    </el-button>
                  </el-form-item> -->
                  <!-- 申领管理 -->
                  <!-- <el-form-item>
                    <el-button type="primary" size="small" @click="handleCurStock()">
                      申领管理
                      <i class="el-icon-back el-icon--right" />
                    </el-button>
                  </el-form-item> -->
                  <el-form-item>
                    <el-button size="small" type="primary" @click="handleBack">
                      返回
                      <i class="el-icon-back el-icon--right" />
                    </el-button>
                  </el-form-item>

                </el-row>
              </div>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </div>

    <el-table
      class="table-list"
      :border="true"
      :data="tableData"
      style="width: 100%"
      row-key="id"
      :expand-row-keys="expandKeys"
      @sort-change="handleResort"
      @expand-change="expandChange"
    >
      <!-- 序号 -->
      <el-table-column label="序号" type="index" width="50px" align="right" fixed="left" />

      <!-- <el-table-column prop="statusDictKey" label="状态" width="100px" sortable="custom" fixed="left">
        <template slot-scope="scope">
          {{ scope.row.statusDictName }}
        </template>
      </el-table-column> -->

      <el-table-column type="expand" label="领">
        <template>
          <div style="margin:20px">
            <el-table :data="subTableData">

              <el-table-column prop="shenlingStatusDictKey" label="申领状态" width="150px" sortable="custom">
                <template slot-scope="scope">
                  {{ scope.row.shenlingStatusDictName }}
                </template>
              </el-table-column>

              <el-table-column prop="shenlingUserId" label="申领者" width="100px" sortable="custom">
                <template slot-scope="scope">
                  {{ scope.row.shenlingUserName }}
                </template>
              </el-table-column>
              <el-table-column prop="shenlingRiqi" label="申领时间" width="120px" sortable="custom">
                <template slot-scope="scope">
                  {{ scope.row.shenlingRiqi | dateFmt('{m}-{d} {h}:{i}') }}
                </template>
              </el-table-column>

              <el-table-column prop="shijihaocaiMingcheng" label="试剂耗材名称" width="180px">
                <template slot-scope="scope">
                  {{ scope.row.stockInfo.shijihaocaiMingcheng }}
                </template>
              </el-table-column>

              <el-table-column prop="shenlingQty" label="申领数量" width="120px" align="right">
                <template slot-scope="scope">
                  <span>{{ scope.row.shenlingQty | decFmt(2) }}</span>
                </template>
              </el-table-column>

              <el-table-column prop="fafangzheUserName" label="发放者" width="100px" />
              <el-table-column prop="fafangQty" label="发放数量" width="120px" align="right">
                <template slot-scope="scope">
                  <span>{{ scope.row.fafangQty | decFmt(2) }}</span>
                </template>
              </el-table-column>

              <el-table-column prop="ketiBianhao" label="课题编号" width="100px" :show-overflow-tooltip="true" />
              <el-table-column prop="ketiMingcheng" label="课题名称" width="150px" :show-overflow-tooltip="true" />
              <el-table-column prop="shiyanMingcheng" label="实验名称" width="150px" :show-overflow-tooltip="true" />
              <el-table-column prop="yongtu" label="用途" min-width="100px" :show-overflow-tooltip="true" />

              <el-table-column label="操作" width="120">
                <template slot-scope="scope">
                  <el-button
                    v-if="scope.row.isFafang"
                    type="primary"
                    size="mini"
                    @click.stop="handleDoFafang( scope.row)"
                  >发放</el-button>
                  <el-button
                    v-if="scope.row.isFafangQueren"
                    type="primary"
                    size="mini"
                    @click.stop="handleDoFafangCorfirm( scope.row)"
                  >确认</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </template>
      </el-table-column>
      <!-- <el-table-column prop="shenqingzheUserName" label="申请者" width="105px">
        <template slot-scope="scope">
          <div style="height:40px; margin: 0 auto; display:table-cell">
            <img v-if="scope.row.shenqingStatusKey==='F0601'" style="height:25px;" src="~@/assets/img/light-red.png">
            <img v-if="scope.row.shenqingStatusKey==='F0602'" style="height:25px;" src="~@/assets/img/light-yellow.png">
            <img v-if="scope.row.shenqingStatusKey==='F0603'" style="height:25px;" src="~@/assets/img/light-green.png">
            <span>{{ scope.row.shenqingzheUserName }}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="caigouUserName" label="采购者" width="100px">
        <template slot-scope="scope">
          <div style="height:40px; margin: 0 auto; display:table-cell">

            <img v-if="scope.row.caigouStatusKey==='F0601'" style="height:25px;" src="~@/assets/img/light-red.png">
            <img v-if="scope.row.caigouStatusKey==='F0602'" style="height:25px;" src="~@/assets/img/light-yellow.png">
            <img v-if="scope.row.caigouStatusKey==='F0603'" style="height:25px;" src="~@/assets/img/light-green.png">
            {{ scope.row.caigouUserName }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="ketiFzrUserName" label="课题负责人" width="100px" :show-overflow-tooltip="true">
        <template slot-scope="scope">
          <div style="height:40px; margin: 0 auto; display:table-cell">

            <img v-if="scope.row.shenpiStatusKey==='F0601'" style="height:25px;" src="~@/assets/img/light-red.png">
            <img v-if="scope.row.shenpiStatusKey==='F0602'" style="height:25px;" src="~@/assets/img/light-yellow.png">
            <img v-if="scope.row.shenpiStatusKey==='F0603'" style="height:25px;" src="~@/assets/img/light-green.png">
            {{ scope.row.ketiFzrUserName }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="shiyongzheUserName" label="使用者" width="100px" /> -->

      <el-table-column prop="shijihaocaiMingcheng" label="试剂耗材名称" width="180px" :show-overflow-tooltip="true">
        <template slot-scope="scope">
          <el-button type="text" @click="handleViewInfo(scope.row)">{{ scope.row.shijihaocaiMingcheng }}</el-button>
        </template>
      </el-table-column>
      <el-table-column prop="pingpai" label="品牌" width="100px" :show-overflow-tooltip="true" />
      <el-table-column prop="guigeQty" label="规格(数量)" width="100px" :show-overflow-tooltip="true" />
      <el-table-column prop="guigeUnit" label="规格(单位)" width="100px" :show-overflow-tooltip="true" />
      <el-table-column prop="shenqingQty" label="申请数量" width="120px" :show-overflow-tooltip="true" />
      <el-table-column prop="shenqingQty" label="采购数量" width="120px" :show-overflow-tooltip="true" />

      <el-table-column prop="stockInCode" label="采购编号" width="120px" />
      <el-table-column prop="kumingchengDictName" label="库名称" width="100px" />
      <el-table-column prop="rukuzheUserName" label="库管员" width="100px" />
      <el-table-column prop="rukuRiqi" label="入库日期" width="100px">
        <template slot-scope="scope">
          <span>{{ scope.row.rukuRiqi | dateFmt }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="jieyu" label="结余" width="120px" align="right">
        <template slot-scope="scope">
          <span>{{ scope.row.jieyu | decFmt(2) }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="jieyu2" label="可用结余" width="120px" align="right">
        <template slot-scope="scope">
          <span>{{ scope.row.jieyu2 | decFmt(2) }}</span>
        </template>
      </el-table-column>

      <el-table-column prop="keshi" label="科室" width="100px" :show-overflow-tooltip="true" />
      <el-table-column prop="jingfeiLaiyuan" label="经费来源" width="100px" :show-overflow-tooltip="true" />
      <el-table-column prop="jingfeiKahao" label="经费卡号" width="100px" :show-overflow-tooltip="true" />
      <el-table-column prop="ketiBianhao" label="课题编号" width="100px" :show-overflow-tooltip="true" />
      <el-table-column prop="ketiMingcheng" label="课题名称" width="150px" :show-overflow-tooltip="true" />
      <el-table-column prop="shiyanMingcheng" label="实验名称" width="150px" :show-overflow-tooltip="true" />
      <el-table-column prop="yongtu" label="用途" width="100px" :show-overflow-tooltip="true" />

      <el-table-column prop="baoxiaozheUserName" label="报销者" width="100px" :show-overflow-tooltip="true" />
      <el-table-column prop="isBaoxiao" label="已报销" width="80px">
        <template slot-scope="scope">
          <span v-if="scope.row.isBaoxiao">是</span>
          <span v-else>否</span>
        </template>
      </el-table-column>

      <el-table-column
        fixed="right"
        label="操作"
        width="230"
        align="center"
      >
        <template slot-scope="scope">

          <!-- 申领 -->
          <el-button
            v-if="scope.row.isDoShenling"
            type="success"
            size="mini"
            @click.stop="handleDoShenling( scope.row)"
          >申领</el-button>

          <!-- 入出库详细 -->
          <el-button
            type="text"
            size="mini"
            @click.stop="handleShowInOut( scope.row)"
          >入出详细</el-button>

          <!-- 再次采购 -->
          <el-button
            type="text"
            size="mini"
            @click.stop="handleReBuy( scope.row)"
          >再次采购</el-button>

        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      background
      layout="prev, pager, next,total,sizes"
      :page-sizes="[10, 20, 50, 100]"
      :page-size="10"
      :total="totalCount"
      @size-change="handleSizeChange"
      @current-change="handleChangePage"
    />
    <Shenqing ref="shenqing" :entity-id="entityId" :rebuy-entity-id="rebuyEntityId" @save-success="handleSearch" />
    <Shenling ref="shenling" :entity-id="entityId" @save-success="handleGoZy02" />
    <AllInfo ref="allinfo" :entity-id="entityId" />
  </div>
</template>

<script>
import pathReq from '@/api/pathlist'
// import ShowUpload from './ShowUpload'
// import UploadExcelComponent from '@/components/UploadExcel/index.vue'
import KxjCom from '@/utils/kxjcom'
import Shenqing from '@/views/managesystem/zy/zy02/edit-shenqing.vue'
import Shenling from '@/views/managesystem/zy/zy02/edit-shenling.vue'
import AllInfo from '@/views/managesystem/zy/zy02/edit-allinfo.vue'
export default {
  components: {
    // Assist,
    Shenqing,
    Shenling,
    AllInfo
    // UploadExcelComponent
  },
  filters: {
    dateFmt(val) {
      return KxjCom.tableDateFormat(val)
    },
    decFmt(val) {
      return KxjCom.tableDecFormat(val)
    }
  },
  data() {
    return {
      moduleCode: 'zy0203',
      tableHeader: [],
      totalCount: 0,
      tableData: [],
      allComboxData: [],
      searchForm: {
        pageNumber: 1,
        pageSize: 10,
        sortKey: '',
        sortOrder: '',
        keyWord: '',
        statusDictKey: 'F0104'
      },
      uploadData: [],
      uploadFormShow: false,
      ketiMemberList: [], // 课题组成员
      entityId: null,
      rebuyEntityId: null,
      expandKeys: [],
      subTableData: []
    }
  },
  computed: {
    getSpac() {
      return '　'
    }
  },
  // 触发
  activated() {
    this.handleSearch()
  },
  // 初期化数据
  created() {
    // 绑定检索
    this.$bus.$off('handleReload')
    this.$bus.$on('handleReload', this.handleSearch)

    this.handleSearch()
    /** 下拉框数据 */
    pathReq.getComboxDatasByIdArray('F01;F02').then(res => {
      this.allComboxData = res.data.result
    })

    const loading = this.$loading(KxjCom.loadOptions)
    pathReq.getForm('api/services/app/Com/GetKetizuMember').then(resp => {
      this.ketiMemberList = resp.data.result
      loading.close()
    })
  },
  mounted() {},
  methods: {
    // combox筛选值
    getComboxData(typeId) {
      return this.allComboxData.filter(function(item) {
        return item.typeId === typeId
      })
    },
    // 每页
    handleSizeChange(val) {
      this.searchForm.pageSize = val
      this.handleSearch()
    },
    // 切页
    handleChangePage(page) {
      this.searchForm.pageNumber = page
      this.handleSearch()
    },
    // 排序
    handleResort(column) {
      this.searchForm.sortKey = column.prop
      this.searchForm.sortOrder = column.order
      this.handleSearch()
    },
    // 新增
    handleAdd() {
      this.entityId = null
      this.$refs.shenqing.show(1)
    },
    // 查询
    handleSearch() {
      const that = this
      const loading = this.$loading(KxjCom.loadOptions)
      var path = '/api/services/app/zy02/GetPagedListzy02s'
      pathReq
        .getList(path, that.searchForm)
        .then(res => {
          loading.close()
          that.totalCount = res.data.result.totalCount
          that.tableData = res.data.result.items
        })
    },
    // 跳转到资源管理主页
    handleGoZy02() {

    },
    /** 查看详情 */
    handleViewInfo(row) {
      this.entityId = row.id
      this.$refs.allinfo.show()
    },
    /** 返回资源管理主页 */
    handleBack() {
      this.$router.push('/zy/zy02')
    },
    // 修改-申请信息
    handleEditShenqing(rowId, formType) {
      this.entityId = rowId
      this.$refs.shenqing.show(formType)
    },
    // 删除-申请信息
    handleDelShenqing(row) {
      const that = this
      this.$confirm('确定要删除该数据吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$loading(KxjCom.loadOptions)
        const path = '/api/services/app/zy02/Deletezy02'
        pathReq.dataDelete(path, row.id).then(res => {
          this.$message.success('删除成功!')
          that.handleSearch()
        })
      })
        .catch(() => {
        })
    },
    /** 做下单 */
    handleDoXiadan(row) {
      this.entityId = row.id
      this.$refs.xiadan.show()
    },
    /** 收货 */
    handleDoShouhuo(row) {
      this.entityId = row.id
      this.$refs.shouhuo.show()
    },
    /** 确认申请信息 */
    handleDoConfirm(row) {
      this.entityId = row.id
      this.$refs.confirm.show()
    },
    /** 修改课题 */
    handleEditKeti(row) {
      this.entityId = row.id
      this.$refs.keti.show()
    },
    /** 入库 */
    handleDoRuku(row) {
      this.entityId = row.id
      this.$refs.ruku.show()
    },
    /** 报销 */
    handleDoBaoxiao(row) {
      this.entityId = row.id
      this.$refs.baoxiao.show()
    },
    /** 申领 */
    handleDoShenling(row) {
      this.entityId = row.id
      this.$refs.shenling.show(false)
    },
    // 只能查看
    handleShowDetail(row, index) {

    },
    // 再次下单
    handleReBuy(row) {
      this.entityId = null
      this.rebuyEntityId = row.id
      this.$refs.shenqing.show(1)
    },
    /**
     * 入出库详细
     */
    handleShowInOut(row) {
      this.$router.push({
        name: 'zy0201',
        params: { zy02id: row.id }
      })
    },
    /**
     * 申领发放
     */
    handleStockOut(id) {
      this.$router.push('/zy/zy0202')
    },
    // 导入
    handleBeforeUpload(file) {
      const isLt5M = file.size / 1024 / 1024 < 5
      if (isLt5M) {
        return true
      }
      this.$message.warning('数据超过5M')
      return false
    },
    handleImportSuccess({ results, header }) {
      const filterVal = [
        'jiShuMingCheng',
        'xueKeLingYuDictKey',
        'leiXingDictKey',
        'fenLeiDictKey',
        'leiBieDictKey',
        'teSe',
        'jianJie'
      ]
      const data = KxjCom.formatJson(header, results)
      var b = []
      for (var i = 0; i < data.length; i++) {
        b.push(KxjCom.formatObj(filterVal, data[i]))
      }
      this.uploadData = b
      for (const row of this.uploadData) {
        row.xueKeLingYuDictKey = KxjCom.getComboxKeyByText(row.xueKeLingYuDictKey, this.getComboxData('D69'))
        row.leiXingDictKey = KxjCom.getComboxKeyByText(row.leiXingDictKey, this.getComboxData('D70'))
        row.fenLeiDictKey = KxjCom.getComboxKeyByText(row.fenLeiDictKey, this.getComboxData('D71'))
        row.leiBieDictKey = KxjCom.getComboxKeyByText(row.leiBieDictKey, this.getComboxData('D72'))
      }

      this.uploadFormShow = true
    },

    expandChange(row, expandedRows) {
      if (this.expandKeys.indexOf(row.id) >= 0) {
        // 收起当前行
        this.expandKeys.shift()
        return
      }
      const that = this
      that.subTableData = []

      const loading = this.$loading(KxjCom.loadOptions)
      var path = '/api/services/app/zy02/GetPagedListzy0202s'
      pathReq
        .getList(path, {
          pageNumber: 1,
          pageSize: 100,
          sortKey: 'shenlingRiqi',
          sortOrder: 'descing',
          zy02Id: row.id
        })
        .then(res => {
          loading.close()
          that.subTableData = res.data.result.items
          that.expandKeys.shift() /** 新增 **/
          that.expandKeys.push(row.id) /** 新增 **/
        })
      if (expandedRows.length > 1) {
        // 只展开当前选项
        expandedRows.shift()
      }
    },
    /** 刷新内部数据 */
    expandChangeByid(id) {
      const that = this
      var path = '/api/services/app/zy02/GetPagedListzy0202s'
      pathReq
        .getList(path, {
          pageNumber: 1,
          pageSize: 100,
          sortKey: 'shenlingRiqi',
          sortOrder: 'descing',
          zy02Id: id
        })
        .then(res => {
          that.subTableData = res.data.result.items
        })
    },
    /** 做发放 */
    handleDoFafang(row) {
      this.$prompt('请输入发放数量', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPattern: /\d/,
        inputErrorMessage: '发放数量格式不正确'
      }).then(({ value }) => {
        const that = this
        var path = '/api/services/app/zy02/DoFaFang'

        const postForm = {
          zy0202Id: row.id,
          fafangQty: value
        }

        pathReq.dataUpdate(path, postForm).then(res => {
          that.$message.success('发放成功')
          this.handleSearch()
          this.expandChangeByid(row.zy02Id)
        }).then(_ => {

        })
      })
    },
    /** 发放确认 */
    handleDoFafangCorfirm(row) {
      const that = this
      var path = '/api/services/app/zy02/DoFaFangCorfirm'

      const postForm = {
        zy0202Id: row.id
      }

      pathReq.dataUpdate(path, postForm).then(res => {
        that.$message.success('发放确认成功')
        this.handleSearch()
        this.expandChangeByid(row.zy02Id)
      }).then(_ => {

      })
    },
    // 导出
    handleExport() {
      this.downloadLoading = true
      import('@/vendor/Export2Excel').then(excel => {
        const tHeader = [
          '状态',
          '试剂耗材名称',
          '品牌',
          '规格(数量)',
          '规格(单位)',
          '采购数量',
          '库管员',
          '采购编号',
          '库名称',
          '个人库',
          '入库日期',
          '结余',
          '科室',
          '课题负责人',
          '经费来源',
          '经费卡号',
          '课题编号',
          '课题名称',
          '实验名称',
          '用途',
          '报销者',
          '已报销'
        ]
        const filterVal = [
          'statusDictName',
          'shijihaocaiMingcheng',
          'pingpai',
          'guigeQty',
          'guigeUnit',
          'shenqingQty',
          'rukuzheUserName',
          'stockInCode',
          'kumingchengDictName',
          'kumingcheng2',
          'rukuRiqi',
          'jieyu',
          'keshi',
          'ketiFzrUserName',
          'jingfeiLaiyuan',
          'jingfeiKahao',
          'ketiBianhao',
          'ketiMingcheng',
          'shiyanMingcheng',
          'yongtu',
          'baoxiaozheUserName',
          'isBaoxiao'
        ]
        const list = this._data.tableData
        const data = KxjCom.formatJson(filterVal, list)
        excel.export_json_to_excel({
          header: tHeader,
          data,
          filename: '试剂耗材', // 非必填
          autoWidth: true, // 非必填
          bookType: 'xlsx' // 非必填
        })
        this.downloadLoading = false
      })
    }

  }
}
</script>

<style scoped>
/* ffc059 */
.upload-btn{
  margin-left: -10px;
}
</style>
